import styled from 'styled-components';
import { breakpoints, colors, fonts, pxToCssFont } from '@vfit/shared/themes';

export const EsimInstructionContainer = styled.div`
  background-color: ${colors.$ffffff};
`;

export const EsimInstructionContent = styled.div`
  padding: 39px 24px;
  margin: 25px auto;
  border-radius: 20px;
  background-color: ${colors.$ffffff};
  color: ${colors.$262626};

  @media (min-width: ${breakpoints.desktop}) {
    padding: 32px 109px;
    max-width: 842px;
  }
`;

export const ImageWrapper = styled.div`
  margin: auto;
  > img: {
    display: block;
    margin: auto;
  }
`;

export const Section = styled.div``;

export const List = styled.ul`
  margin-top: unset;
  padding: 5px 25px;
`;

export const ListItem = styled.li`
  margin-bottom: 10px;
`;

export const ButtonWrapper = styled.div`
  width: 280px;
  margin: auto;
`;

